<div class="campaign-shahkar-error-container">
  <ngx-app-bar
    class="w-100"
    [title]="'بررسی حساب سجام'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />
  <div class="campaign-shahkar-error-content">
    <img src="wealth-assets/svg/national-id-error.svg" />
    <p class="campaign-shahkar-error-description">کد ملی موجود در حساب کاربری شما متعلق به مالک شماره {{ state?.phoneNumber }} نیست.</p>
  </div>
  <div class="w-100 campaign-shahkar-error-buttons">
    <ngx-button
      [buttonId]="'CAMPAIGN_NATIONAL_ID'"
      [style]="'fill'"
      [fullWidth]="true"
      (clickHandler)="onBackHandler()"
    >
      تغییر کد ملی
    </ngx-button>
  </div>
</div>
